import { AxiosInstance } from "api/axiosInstance";
import {
  BasePagination,
  CommonResponse,
} from "api/interfaces/commonInterface.interface";
import {
    CreateFirmwarePackageRequest,
  CreateFirmwarePackageResponse,
  FeaturesPopupDetailResponse,
  FirmwarePackageUploadStatusResponse,
  GetFeaturesPopupListResponse,
  UploadStatusFirmwareRequest,
} from "api/interfaces/settingsInterface.interface";
import axios, { AxiosResponse } from "axios";
import qs from "qs";
const API_PATH = "/setting/announcement";

export const getFeaturesPopupList = async ({
  payload,
}: {
  payload: BasePagination;
}): Promise<GetFeaturesPopupListResponse> => {
  try {
    const { data }: AxiosResponse<GetFeaturesPopupListResponse> =
      await AxiosInstance.get(
        `${API_PATH}/list?${qs.stringify(payload)}`
      );
    return data;
  } catch (e) {
    throw e;
  }
};

export const getFeaturesPopupDetail = async (
  id: string
): Promise<FeaturesPopupDetailResponse> => {
  try {
    const { data }: AxiosResponse<FeaturesPopupDetailResponse> =
      await AxiosInstance.get(`${API_PATH}/detail`);
    return data;
  } catch (e) {
    throw e;
  }
};

export const postNeverMind = async (id: string): Promise<CommonResponse> => {
  try {
    const { data }: AxiosResponse<CommonResponse> = await AxiosInstance.post(
      `${API_PATH}/neverRemind`,
      {
        id: id,
      }
    );
    return data;
  } catch (e) {
    throw e;
  }
};

export const postFeaturesPopup = async (
  payload: FormData
): Promise<FeaturesPopupDetailResponse> => {
  try {
    const { data }: AxiosResponse<FeaturesPopupDetailResponse> =
      await AxiosInstance.post(`${API_PATH}/create`, payload);
    return data;
  } catch (e) {
    throw e;
  }
};
  
  
  export const putFeaturesPopup = async ({
    id,
    payload,
  }: {
    id: string;
    payload: FormData;
  }): Promise<FeaturesPopupDetailResponse> => {
    try {
      const { data }: AxiosResponse<FeaturesPopupDetailResponse> =
        await AxiosInstance.put(`${API_PATH}/update/${id}`, payload);
      return data;
    } catch (e) {
      throw e;
    }
  };

export const deleteFeaturesPopup = async (
    id: string
  ): Promise<FeaturesPopupDetailResponse> => {
    try {
      const { data }: AxiosResponse<FeaturesPopupDetailResponse> =
        await AxiosInstance.delete(`${API_PATH}/delete/${id}`);
      return data;
    } catch (e) {
      throw e;
    }
  };
  